import { render } from "./Image.vue?vue&type=template&id=77cd36e0&scoped=true&ts=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=77cd36e0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cd36e0"]])

export default __exports__